import { API } from './api';

export const submitForgotPassword = (email) => {
  return API().post('forgot_password', { email });
};
